import React from "react";

const Toast = ({ message, show, onClose, variant = "success" }) => {
  if (!show) return null;
  const isError = variant === "error";
  return (
    <div
      role="alert"
      className={`fixed top-6 right-6 z-[100] max-w-md text-white px-5 py-3 rounded-xl shadow-lg font-semibold border animate-fade-in ${
        isError
          ? "bg-red-600 border-red-700"
          : "bg-green-600 border-green-700/40"
      }`}
    >
      <span className="text-sm leading-snug">{message}</span>
      <button
        type="button"
        className="ml-3 text-white font-bold text-lg align-top"
        onClick={onClose}
        aria-label="Close Toast"
      >
        &times;
      </button>
    </div>
  );
};

export default Toast;
